import React, { useMemo } from "react";
import { IColuna } from "app/types/IColuna";
import { AcoesHeadPesquisaPreVenda } from "./AcoesHeadPesquisaPreVenda";
import { HeadersPesquisaPreVendas } from "./HeadersPesquisaPreVendas";

export type TableHeadPesquisaPreVendasProps = {
  onAlterarFonte: (tamanho: number) => void;
  tamanhoFonte: number;
  colunas: IColuna[];
  onToggleSelecionarTodasColunas: (selecionar: boolean) => void;
  onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void;
  permitirEngrenagemGrid: boolean
};

export const TableHeadPesquisaPreVendas = React.memo((
  props: TableHeadPesquisaPreVendasProps
) => {
  // <thead> só aceita <tr> como filho direto — a barra de ações (engrenagem/fonte) vira um <th>
  // único ocupando todas as colunas selecionadas (mesmo padrão de TableHeadPesquisaProdutos.tsx,
  // usado na grade principal de pesquisa de produtos).
  const colSpanMenu = useMemo(
    () => Math.max(1, props.colunas.filter((c) => c.Selecionada).length),
    [props.colunas]
  );

  return (
    <thead>
      <tr>
        <th
          colSpan={colSpanMenu}
          id="TableHeadPesquisaPreVendas_LinhaMenu"
          style={{ textAlign: "left" }}
        >
          <div id="TableHeadPesquisaPreVendas_ContainerMenuColunas">
            <AcoesHeadPesquisaPreVenda
              permitirEngrenagemGrid={props.permitirEngrenagemGrid}
              colunas={props.colunas}
              onToggleColunaSelecionada={props.onToggleColunaSelecionada}
              onToggleSelecionarTodasColunas={props.onToggleSelecionarTodasColunas}
              onAlterarFonte={props.onAlterarFonte}
              tamanhoFonte={props.tamanhoFonte}
            />
          </div>
        </th>
      </tr>

      <HeadersPesquisaPreVendas colunas={props.colunas} />
    </thead>
  );
});
